import { Link } from "react-router-dom";

const SomethingWentWrong = ({ errorTitle, errorMessage, resetState }) => {
  return (
    <div className="something-went-wrong">
      <h1>Oops, something went wrong</h1>
      <p>
        This page is currently not available. We are working on the problem, and
        appreciate your patience.
      </p>
      <Link onClick={resetState} to="/login">
        Back To Login
      </Link>
    </div>
  );
};

export default SomethingWentWrong;
